
<po-page-edit p-title="Gestão de orçamentos">
  <div class="po-row">
    <po-input
      class="po-md-5"
      name="buscarcamento"
      p-label="Filtrar orçamento"
      [(ngModel)]="bOrcamento"
      (p-change-model)="buscaOrcamento()"
      p-icon="po-icon po-icon-search"
    >
    </po-input>
    

    
  </div>
  <po-table
    p-sort="true"
    p-container="light"
    [p-columns]="columns"
    [p-items]="orcamentoList"
    [p-loading]="loading"
    [p-actions]="actions"
    p-container="shadow"
    p-hide-text-overflow="true"
    p-height="600"
    p-striped="true"
  >
  </po-table>
</po-page-edit>
